webpackJsonp([201318145584323],{

/***/ 551:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Nick Long's Blog","subtitle":"Engineer & Musician","copyright":"© Nick Long 2018 All rights reserved.","menu":[{"label":"Articles","path":"/"},{"label":"About me","path":"/about/"}],"author":{"name":"Nick Long","email":"#","telegram":"#","twitter":"monquixote","github":"monquixote","rss":"./rss.xml","vk":"#"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/the-prestige-review/","categorySlug":"/categories/review/"},"frontmatter":{"title":"The Prestige - Review","date":"2006-11-21T15:22:00.000Z","category":"Review","description":null}}}]}},"pathContext":{"tag":"movie"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-movie-3c6cda0af6adf7486392.js